import React, { useEffect, useState, useRef } from 'react';
import { updateName, updateShortName} from './helpers/racefunctions';
import { Modal } from 'bootstrap';

export function AccountName({walletAddress, setMessage, setModalInfo, displayOnly, dets, accountName, setAccountName}) {

    const accForChange = useRef("");
    const abbForChange = useRef("");

    const [shortName, setShortName] = useState("");
    const [showChange, setShowChange] = useState(false);
    const [showAbbChange, setShowAbbChange] = useState(false);

    useEffect(() => {
        setShowChange(false);
        const loadAccountName = async() => {
        if(accountName !== undefined){
            setShortName(accountName.shortName);
        }
    }
    if (walletAddress !== ''){
        loadAccountName();
    }

    },[walletAddress, accountName])

    const nameChange = () => {
        setShowChange(!showChange);
    }

    const abbChange = () => {
        setShowAbbChange(!showAbbChange);
    }

    const cancelNameChange = () => {
        accForChange.current.value = (accountName.accName === 'Account name not set.' ? '' : accountName.accName);
        setShowChange(false);
        setMessage("");
    }

    const cancelAbbChange = () => {
        abbForChange.current.value = (shortName === 'Abbreviated name not set.' ? '' : shortName);
        setShowAbbChange(false);
        setMessage("");
    }

    const updateShortNameClick = async() => {
        if (abbForChange.current.value === accountName.shortName){
            alert('Abbreviation was not changed');
            return false;
        }
        if (abbForChange.current.value === ''){
            //setMessage('Abbreviated name cannot be blank');
            alert('Abbreviated name cannot be blank');
        }else{
            setMessage("");
            var myNameModal = new Modal(document.getElementById('showAlerts'));
            setModalInfo({"message":'Waiting on abbreviation update.',"type":'abbstart'})
            myNameModal.show();
            const updateResp = await updateShortName(walletAddress, abbForChange.current.value, 0);
            console.log(updateResp);
            if (updateResp !== undefined){
                if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
                    
                    setModalInfo({"message":"Abbreviation updated.", "type":"abbupdated" });
                    setShortName(abbForChange.current.value);
                    let tempAccountName = {...accountName};
                    tempAccountName.shortName = abbForChange.current.value;
                    setAccountName(tempAccountName);
                    setShowAbbChange(false);
                    
                }else {
                    setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                    return false;
                }
             } else {
                    setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                    return false;
             }
        }
    }

    const updateAccName = async () => {
        if (accForChange.current.value === accountName.accName){
            alert('Account name was not changed');
            return false;
        }
        if (accForChange.current.value === ''){
            alert('Account name cannot be blank.');
        }else{
            setMessage("");
           // const nameCheck = await checkAccountName(accForChange.current.value);
           // if (nameCheck){
           //     setMessage("This account name is already in use.");
           //     return false;
           // }
            var myNameModal = new Modal(document.getElementById('showAlerts'));
            setModalInfo({"message":'Waiting on account update.',"type":'accstart'})
            myNameModal.show();
            const updateResp = await updateName(walletAddress, accForChange.current.value, 0);
            console.log(updateResp);
            if (updateResp !== undefined){
                if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
                    
                    setModalInfo({"message":"Account name updated.", "type":"accupdated" });
                    let tempAccountName = {...accountName};
                    tempAccountName.accName = accForChange.current.value;
                    setAccountName(tempAccountName);
                    setShowChange(false);
                    
                }else {
                    setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                    return false;
                }
             } else {
                    setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                    return false;
             }
        }
    }

    if (walletAddress === ''){
            return <div></div>
    }else{
        if (displayOnly){
            return <div>Welcome <span style={{paddingLeft:'5px', paddingRight:'5px', fontSize:'1.1em'}}>{accountName.accName}!</span></div>
        }else{

                return <div><div className='createFormat' style={{fontWeight:'bold', paddingBottom:'25px', paddingTop:'2%'}}>Team Name:</div><div style={{marginLeft:'20px', display:(showChange ? 'block' : 'none')}}><input type="text" id="accountchange" ref={accForChange} defaultValue={ (accountName.accName === 'Account name not set.' ? '' : accountName.accName)} /> <button style={{color:'white', paddingLeft:'5px', paddingRight:'5px', cursor:'pointer', background:'none', border:'none', textDecoration:'underline'}} onClick={() => updateAccName()}>Update</button><button style={{color:'white',paddingLeft:'5px', paddingRight:'5px',background:'none', border:'none',  cursor:'pointer', textDecoration:'underline'}} onClick={() => cancelNameChange()}>Cancel</button></div>
                       <div style={{marginLeft:'20px',display:(showChange ? 'none' : 'block')}}><span style={{fontWeight:'bold', fontSize:'1.1em', color: 'gold'}}>{accountName.accName}</span><div style={{paddingTop:'2%'}}><button style={{color:'blue', background:'none', border:'none', cursor:'pointer', textDecoration:'underline'}} onClick={() => nameChange()}>(change)</button></div></div>
                       <div className='createFormat' style={{fontWeight:'bold', paddingTop:'20px'}}>Team Abbreviation:</div>
                       <div className='createFormat' style={{fontSize:'.8em'}}>(displayed on leaderboard)</div>
                       <div style={{marginLeft:'20px', display:(showAbbChange ? 'unset' : 'none')}}><input type="text" id="abbchange" ref={abbForChange} defaultValue={ (shortName === 'Abbreviated name not set.' ? '' : shortName)} /> <button style={{color:'white', paddingLeft:'5px', paddingRight:'5px', background:'none', border:'none',  cursor:'pointer', textDecoration:'underline'}} type="button" onClick={() => updateShortNameClick()}>Update</button><button style={{color:'white', paddingLeft:'5px', paddingRight:'5px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline'}} onClick={() => cancelAbbChange()}>Cancel</button></div>
                       <div style={{marginLeft:'20px',display:(showAbbChange ? 'none' : 'block'), color: 'gold'}}><span style={{fontWeight:'bold', fontSize:'1.1em'}}>{shortName}</span><div style={{paddingTop:'2%'}}><button style={{cursor:'pointer', color:'blue', background:'none', border:'none',  textDecoration:'underline'}} onClick={() => abbChange()}>(change)</button></div></div>
                       </div>

        }
        
    }


    }